<main>
    <header>
        <h1 class="main-title">
            <img class="img-fluid title-img"
                src="./icon.png"
                alt="assisteer logo"
            />
            <img class="img-fluid title-img"
                src="./name.png"
                alt="assisteer logo"
            />
        </h1>
    </header>
</main>

<style>
    h1 {
        font-size: max(8vw, 50px);
    }
    .title-img {
        height: min(1em, 130px);
    }
</style>
